class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.accordions = this.querySelectorAll(':scope > div')
    if(this.accordions.length == 0) return;

    this.accordions.forEach((accordion) => {
      accordion.addEventListener('click', function(){
        const icon_plus = accordion.querySelector('[data-icon-plus]');
        const icon_minus = accordion.querySelector('[data-icon-minus]');
        const content = accordion.querySelector('[data-content]');
    
        if (accordion.getAttribute('data-state') == 'active') {
          accordion.setAttribute('data-state','') 
          content.classList.remove('vf-block');
          content.classList.add('vf-hidden');
          icon_plus.classList.remove('vf-block');
          icon_plus.classList.add('vf-hidden');
          icon_minus.classList.add('vf-block');
          icon_minus.classList.remove('vf-hidden');
        } else {
          this.removeActiveAccordions();
          accordion.setAttribute('data-state','active')
          content.classList.remove('vf-hidden');
          content.classList.add('vf-block');
          icon_plus.classList.remove('vf-hidden');
          icon_plus.classList.add('vf-block');
          icon_minus.classList.add('vf-hidden');
          icon_minus.classList.remove('vf-block');
          accordion.scrollIntoView();
        }
      }.bind(this));
    });
  }


  removeActiveAccordions() {
    this.accordions.forEach((accordion) => {
      const icon_plus = accordion.querySelector('[data-icon-plus]');
      const icon_minus = accordion.querySelector('[data-icon-minus]');
      const content = accordion.querySelector('[data-content]');

      accordion.setAttribute('data-state','')
      content.classList.remove('vf-block');
      content.classList.add('vf-hidden'); 
      icon_plus.classList.remove('vf-block');
      icon_plus.classList.add('vf-hidden');
      icon_minus.classList.add('vf-block');
      icon_minus.classList.remove('vf-hidden');
    });
  }
}

customElements.define('accordion-component', AccordionComponent);
